import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class LoginComponent {

  username: string;
  password: string;

  constructor(
    private authService: AuthService
  ) {
  }

  submit() {

    this.authService.login(this.username, this.password);

  }
}
